import { properties } from "@repoflow/common/schema-fields";
import { siteKey } from "@common/schema/site/key";
import {
  html,
  style,
  script,
  types,
  values,
  storedTypes,
  storedValues,
} from "@common/schema/content/fields";

const { createdAt, updatedAt } = properties;

export {
  createdAt,
  updatedAt,
  html,
  style,
  script,
  types,
  values,
  storedTypes,
  storedValues,
};

// The partition: `${orgId}/${siteId}`. See @common/schema/site/key.
export { siteKey };

export const orgId = {
  type: "string",
};

export const siteId = {
  type: "string",
};

// Chosen by the caller, not minted — a section is referred to by name from
// every page that carries it ("navbar", "footer"), so a uuid would make the
// element editor unreadable. That is why the model opts into
// `createIfNotExists`: with a caller-chosen key, a plain put silently replaces
// somebody else's section.
//
// /Name/Required is lowercase-kebab and non-empty. It comes from
// @repoflow/schema/utils, which every schema in this tree already spreads.
export const sectionId = {
  label: "Name",
  $ref: "/Name/Required",
  minLength: 1,
  default: "",
};

// The EJS wrapper the section's markup lands inside. Copied onto a page element
// when the section is selected there and then allowed to diverge, which is how
// one section renders as a header on one page and inline on another.
export const frame = {
  label: "Frame",
  type: "string",
  textarea: true,
  default: "<div><%-content%></div>",
};

export const tags = {
  label: "Tags",
  type: "array",
  items: { type: "string" },
  widget: "tags",
  default: [],
};

export const status = {
  type: "string",
};
